import type { AccordionProps } from '@tvg/fuse/accordion';

export const FILTER_DRAWER_BUTTON_ID = 'facet-drawer-button';

export const ACCORDION_TITLE_SIZE: AccordionProps['titleSize'] = {
  xxs: 'xxsmall',
};
